<template>
  <div class="login">
    <div class="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 mx-auto">
        <b-card :title="$t('log_in')" 
                class="text-center ">

                      <form v-on:submit.prevent="login()" novalidate class="is-invalid">
              <div class="form-group field-login-form-login">
                <label class="control-label">{{ $t('login') }}</label>
                <input type="text" class="form-control" v-model="data.body.username" required>
                  <div class="help-block"></div>
              </div>                
              <div class="form-group field-login-form-password">
                <label class="control-label">{{ $t('password') }}</label>
                <input v-model="data.body.password" type="password" class="form-control" v-bind:class="{ 'is-invalid': error  }" required>
                  <div class="invalid-feedback" v-show="error">{{ error }}</div>
                  <div class="help-block"></div>
              </div>                
              <div class="form-group field-login-form-rememberme">
                <label><input v-model="data.rememberMe" type="checkbox"> {{ $t('remember') }}</label>
                <div class="help-block"></div>
              </div>
                <b-button v-if="logging" disabled   class="btn btn-primary btn-block">Идёт авторизация</b-button>
              <b-button v-else type="submit" class="btn btn-primary btn-block">{{ $t('log_in') }}</b-button>
              <b-progress v-if="logging" :value="logging" variant="success" striped :animated="animate"></b-progress>
            </form> 
        </b-card>
        <p class="text-center">
          <router-link to="/forgot" class="btn btn-sm m-2">{{ $t('forgot') }}</router-link>
          <router-link v-if="1!==1" to="/resend" class="btn btn-sm m-2">{{ $t('reset') }}</router-link>
          <router-link to="/register" class="btn btn-sm btn-success">{{ $t('register') }}</router-link>
        </p>
      </div>
  </div>
</template>
<i18n>
{
  "en": {
    "login": "Email or phone number",
    "password": "Password",
    "remember": "Remember me",
    "log_in": "Log In",
    "forgot": "Forgot your password?",
    "reset": "Did not receive the letter?",
    "register": "No account? Sign up!"
  },
  "ru": {
    "login": "Электронный адрес или номер телефона",
    "password": "Пароль",
    "remember": "Запомнить меня",
    "log_in": "Войти",
    "forgot": "Забыли пароль?",
    "reset": "Не пришло письмо?",
    "register": "Нет аккаунта? Зарегистрируйтесь!"
  }
}
</i18n>
<script>
  export default {
    data () {
      return {
        context: 'login context',
            timer:null,
            logging:false,
        data: {

          body: {
            username: '',
            password: ''
          },
          rememberMe: false,
          fetchUser: true
        },
        error: null
      }
    },

    mounted () {
      console.log(this.$auth.redirect())

      // Can set query parameter here for auth redirect or just do it silently in login redirect.
    },

    methods: {
      login () {
        var redirect = this.$auth.redirect()
        this.logging=0
        this.timer = setInterval(() => {
            if(this.logging<100){
        this.logging+=10
    }
      }, 100)
        this.$auth.login({
          // body: this.data.body, // Vue-resource
          data: this.data.body, // Axios
          rememberMe: this.data.rememberMe,
          fetchUser: this.data.fetchUser,
          redirect: '/user',
        })
        .then(response => {
            clearInterval(this.timer)
            this.logging=false
          console.log('success ' + this.context)
        }).catch(e => {
            clearInterval(this.timer)
            this.logging=false
          this.error = e.response.data
        })
      }
    }
  }
</script>